// extracted by mini-css-extract-plugin
module.exports = {"place":"Timeline_place__1cN1-","duration":"Timeline_duration__2W0_V"};